const RENEW_ACCESS_TOKEN = "/api/v1/auth/renew-access-token/";
const USER_LOGOUT = "/api/auth/logout/";
const PACKAGE_NAME = "com.seekho.ams";

export { RENEW_ACCESS_TOKEN, USER_LOGOUT, PACKAGE_NAME };
